import React from 'react';
import logozgt from '../assets/Logo-ZGT-white.png';
import logorenergie from '../assets/Logo-renergie-white.png';
import './Footer.css';

const Footer: React.FC = () => (
  <section className="footer-section">
    <div className="footer-container">

      <hr className="footer-divider" />

      <div className="footer-row">
        <div className="footer-left">
          <img src={logozgt} alt="Logo ZGT" className="footer-logo" />
        </div>
        <div className="footer-right">
          <p>Gesellschaft für Energie- und Versorgungstechnik mbH</p>
          <p>Andreas-Hofer-Straße 6</p>
          <p>87452 Altusried</p>
          <p>info@zgt-ingenieure.de</p>
          <p>+49 8373 59449-0</p>
        </div>
      </div>

      <hr className="footer-divider" />

      <div className="footer-row">
        <div className="footer-left">
          <img src={logorenergie} alt="Logo renergie" className="footer-logo" />
        </div>
        <div className="footer-right">
          <p>Verein für erneuerbare Energien & Energieeffizienz</p>
          <p>Burgstraße 26</p>
          <p>87435 Kempten</p>
          <p>zentrale@renergie-allgaeu.de</p>
          <p>+49 831 52 62 68 0-0</p>
        </div>
      </div>

      <hr className="footer-divider" />
      
    </div>
  </section>
);

export default Footer;
